module.exports = __webpack_public_path__ + "img/2025-0423-01-02.572df117.png";